// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_GO_PREVIOUS_STEP,
} from './constants';

export function goPreviousStep(id) {
  return {
    type: SIMULADOR_FINANCIERO_GO_PREVIOUS_STEP,
    currentStep: id
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_GO_PREVIOUS_STEP:
      const aux = state.altaLineaSettings.pasos;
      let selected = null;
      aux.forEach((paso) => {
        if (paso.id <= action.currentStep) {
          paso.active = true;
        } else {
          paso.active = false;
        }
        if (paso.id === action.currentStep) {
          paso.selected = true;
          selected = paso;
        } else {
          paso.selected = false;
        }
      });

      return {
        ...state,
        altaLineaSettings: {
          pasos: aux,
          pasoSelected: selected
        }
      };

    default:
      return state;
  }
}
